import { AmberHoc, AmberHocProps } from '../../../util';
import {
  SaveOperationsViewUserLevelPrefsMutation,
  SaveOperationsViewUserLevelPrefsMutationVariables as Variables,
  withSaveOperationsViewUserLevelPrefs as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithSaveOperationsViewUserLevelPrefsHocChildProps = {
  saveOperationsViewUserLevelPrefs: (
    variables: Variables
  ) => Promise<SaveOperationsViewUserLevelPrefsMutation['saveOperationsViewUserLevelPrefs']>;
};
export const withSaveOperationsViewUserLevelPrefsHoc: AmberHoc<
  {},
  WithSaveOperationsViewUserLevelPrefsHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithSaveOperationsViewUserLevelPrefsHocChildProps, typeof component>,
    WithSaveOperationsViewUserLevelPrefsHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        saveOperationsViewUserLevelPrefs: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: async (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
              const { saveOperationsViewUserLevelPrefs: updated } = data;
              if (!updated) {
                return;
              }
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { data, errors } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data || !data.saveOperationsViewUserLevelPrefs) {
            throw new Error('Unexpected server response');
          }
          return data.saveOperationsViewUserLevelPrefs;
        },
      };
    },
  })(component as any);
